// removed by extract-text-webpack-plugin
module.exports = {"animated":"_5epXm"};